import type { TranslationSchema } from '../zh';

const pricing: TranslationSchema['pricing'] = {
  title: 'Mua / Nâng cấp',
  cycle_month: 'Tháng',
  cycle_year: 'Năm',
  per_month: '/ tháng',
  per_year: '/ năm',
  days: '{{count}} ngày',
  months: '{{count}} tháng',
  original: 'Giá gốc: {{price}}{{unit}}',
  per_day: 'Chỉ từ ¥{{price}}/ngày',
  start_trial: 'Dùng thử',
  current_plan: 'Gói hiện tại',
  upgrade: 'Nâng cấp',
  current_badge: 'Hiện tại',
  purchase_pending: 'Thanh toán sẽ sớm mở',
  plans_load_failed: 'Không tải được gói',
  no_plans: 'Chưa có gói để hiển thị',
  packages_load_failed: 'Không tải được gói quyền lợi',
  no_packages: 'Chưa có gói quyền lợi để mua',
  permanent: 'Vĩnh viễn',
  no_price: 'Khu vực này chưa có giá',
  select_spec: 'Chọn gói',
  buy: 'Mua',
  buy_now: 'Mua ngay',
  unavailable: 'Chưa thể mua',
  basic_included: 'Dùng ngay khi đăng ký, không cần mua.',
  not_supported: 'Không hỗ trợ',
  per_day_amount: 'Chỉ từ {{price}} / ngày',
  currency: 'Tiền tệ',
  currency_cny: 'Nhân dân tệ',
  pay_method: 'Phương thức thanh toán',
  pay_wechat: 'WeChat',
  pay_alipay: 'Alipay',
  pay_bank: 'Chuyển khoản',
  plan_price: 'Giá gói',
  coupon: 'Mã giảm giá',
  select_coupon: 'Chọn mã',
  pay_amount: 'Thanh toán',
  pay_now: 'Thanh toán ngay',
  agree_terms: 'Thanh toán đồng nghĩa chấp nhận thỏa thuận người dùng',
  benefits: 'Quyền lợi',
  pay_channel_unsupported: 'Phương thức thanh toán này chưa mở',
  pay_create_failed: 'Không tạo được đơn',
  pay_waiting: 'Vui lòng hoàn tất thanh toán',
  pay_qr_hint: 'Quét mã bằng ứng dụng tương ứng để thanh toán',
  pay_open_link: 'Mở trang thanh toán',
  pay_success: 'Thanh toán thành công',
  pay_failed: 'Thanh toán thất bại',
  pay_closed: 'Thanh toán đã đóng',
  pay_polling: 'Đang chờ kết quả thanh toán…',
  pay_order_no: 'Đơn {{orderNo}}',
  pay_invalid_sku: 'Chọn mức giá hợp lệ',
  pay_invalid_plan: 'Thiếu mã gói',
  pay_invalid_package: 'Thiếu mã gói quyền lợi',
  pay_invalid_amount: 'Số tiền không hợp lệ',
  period_DAY: 'ngày',
  period_WEEK: 'tuần',
  period_MONTH: 'tháng',
  period_TOTAL: 'tổng',
  period_NONE: 'liên tục',
  trial_name: 'Dùng thử',
  trial_desc: '2 cửa hàng · 10 email (dùng thử)',
  pro_name: 'Chuyên nghiệp',
  pro_desc: '5 cửa hàng · 3.000 email/tháng',
  deluxe_name: 'Cao cấp',
  deluxe_desc: '10 cửa hàng · 10.000 email/tháng',
  feat_square: 'Quảng trường KOL',
  feat_dm: 'Tin nhắn',
  feat_mailbox: 'Hộp thư nền tảng',
  feat_shops: 'Cửa hàng ủy quyền',
  feat_trial_all: 'Toàn bộ quyền dùng thử',
  feat_script: 'Mẫu kịch bản',
  feat_invite: 'Lời mời định hướng',
  feat_dedupe: 'Chống trùng tần suất cao',
  feat_email: 'Hạn mức email',
  feat_pro_all: 'Toàn bộ gói Chuyên nghiệp',
  feat_dashboard: 'Bảng dữ liệu nhóm',
  feat_members: 'Quản lý thành viên',
  feat_ticket: 'Ưu tiên hỗ trợ',
  quota_mail_trial: '10 email',
  quota_mail_pro: '3.000 email/tháng',
  quota_mail_deluxe: '10.000 email/tháng',
  quota_shop_2: '2 cửa hàng',
  quota_shop_5: '5 cửa hàng',
  quota_shop_10: '10 cửa hàng'
};

export default pricing;
